exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid-thumbnail {\n  overflow: hidden;\n  text-align: center;\n  position: relative;\n  float: left;\n  height: 100%;\n  width: 100%;\n  /*height: 12.6vw;\r\n  width: 12.6vw;*/\n  line-height: 11.6vw;\n  border: 1px solid #e5e8eb;\n  text-align: center;\n  display: inline-block; }\n  .grid-thumbnail img {\n    margin: auto;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    max-width: 100%;\n    max-height: 100%; }\n  .grid-thumbnail i.zmdi {\n    font-size: 2.6vw; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/shared/components/media-thumbnail/media-thumbnail.component.scss
// module id = 1465
// module chunks = 18